<template>
  <div class="access-denied">
    <!-- Capas espaciales -->
    <div class="stars"></div>
    <div class="twinkling"></div>
    <div class="planets"></div>

    <!-- Contenido -->
    <div class="content">
      <img src="@/assets/images/AccessDenied.png" alt="Acceso Denegado" class="denied-img" />
      <h1>Acceso Denegado</h1>
      <p>No tienes permisos para acceder a esta secci&oacute;n.</p>
      <button @click="$router.push({ path: '/' })">Ir al inicio</button>
    </div>
  </div>
</template>

<style scoped>
  .access-denied {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(180deg, #001a33, #003366);
  }

  /* Estrellas */
  .stars {
    width: 200%;
    height: 200%;
    background: transparent url("https://www.transparenttextures.com/patterns/stardust.png") repeat;
    position: absolute;
    top: 0;
    left: 0;
    animation: moveStars 100s linear infinite;
  }

  /* Estrellas parpadeando */
  .twinkling {
    width: 200%;
    height: 200%;
    background: transparent url("https://www.transparenttextures.com/patterns/tiny-cross-hatch.png") repeat;
    position: absolute;
    top: 0;
    left: 0;
    animation: twinkling 200s linear infinite;
    opacity: 0.5;
  }

  /* Planetas y nebulosas */
  .planets {
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 20% 30%, rgba(51, 102, 153, 0.6), transparent 40%),
                radial-gradient(circle at 80% 70%, rgba(0, 102, 204, 0.5), transparent 35%),
                radial-gradient(circle at 60% 20%, rgba(255, 255, 255, 0.2), transparent 30%);
    animation: floatPlanets 60s ease-in-out infinite alternate;
  }

  @keyframes moveStars {
    from { transform: translateX(0); }
    to { transform: translateX(-1000px); }
  }

  @keyframes twinkling {
    from { transform: translateY(0); }
    to { transform: translateY(-1000px); }
  }

  @keyframes floatPlanets {
    0% { transform: translateY(0) translateX(0); }
    50% { transform: translateY(-30px) translateX(20px); }
    100% { transform: translateY(20px) translateX(-15px); }
  }

  /* Recuadro del contenido */
  .content {
    text-align: center;
    max-width: 400px;
    padding: 20px;
    border-radius: 12px;
    background: #fff; /* Mantiene el color original */
    box-shadow: 0 4px 12px rgba(0,0,0,0.4);
    color: white;
    z-index: 2;
    position: relative;
  }

  .denied-img {
    width: 200px;
    margin-bottom: 20px;
  }

  h1 {
    color: #d32f2f;
    margin-bottom: 10px;
  }

  p {
    color: #555;
    margin-bottom: 20px;
  }

  button {
    background-color: #d32f2f;
    color: #fff;
    border: none;
    padding: 10px 18px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: bold;
  }

  button:hover {
    background-color: #b71c1c;
  }
</style>

<script>
  export default {
    name: "AccessDenied",
    methods: {
    }
  }
</script>
